// DS: i3.44
import React from 'react';
import IconWrap from '../../IconWrap';
const Boost = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        d: "M20.204 2.507a1.173 1.173 0 011.29 1.291l-.606 5.92a1.18 1.18 0 01-.337.713l-4.892 4.924-.968 3.19a1.177 1.177 0 01-.45.623l-3.031 2.12c-.524.367-1.105.2-1.426-.066a1.208 1.208 0 01-.37-1.341c.678-1.878.285-3.638-.65-4.37-1.279-.998-2.86-1.103-4.806-.637-1.005.24-1.88-.898-1.24-1.824L4.94 9.827a1.17 1.17 0 01.629-.458l3.203-.954 4.899-4.93c.188-.19.435-.31.7-.339l5.833-.639zm-.748 2.056l-4.601.504L9.8 10.155l-3.416 1.017-1.031 1.497c1.609-.115 3.197.193 4.606 1.293 1.358 1.062 1.86 2.838 1.717 4.611l1.23-.86 1.031-3.4 5.04-5.073.48-4.677zM17.14 8.36c0 .812-.655 1.471-1.462 1.471a1.467 1.467 0 01-1.462-1.471c0-.813.655-1.472 1.462-1.472.807 0 1.462.66 1.462 1.472zM3.083 20.966c-.083.172.096.352.266.269l4.224-2.065a.201.201 0 00.054-.322L5.454 16.66a.199.199 0 00-.32.054l-2.051 4.253z",
        clipRule: "evenodd"
    })));
};
Boost.displayName = 'Boost';
export default Boost;

//# sourceMappingURL=Boost.js.map